import { FREE_TRIAL_DAYS } from 'constants/billing';
import { SettingUrls } from 'constants/SettingsUrls';
import { PackageProviderName } from 'data/ppoints/constants';
import { useShowFreeTrial } from 'features/settings/components/ppoints/dashboard/dashboard-welcome/hooks/useShowFreeTrial';
import { useServiceProviderPlanLimit } from 'features/wizard/hooks/useServiceProviderPlanLimit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

interface ServiceProviderPlanLimitBannerProps {
    /** Providers currently selected in the wizard step, not yet saved */
    selectedProviders: PackageProviderName[];
}

/**
 * Warns that the selection would activate more carriers than the current plan allows, before the merchant
 * tries to save it. Self-guards on that check, so it can be rendered unconditionally below the selector.
 */
export const ServiceProviderPlanLimitBanner: React.FC<ServiceProviderPlanLimitBannerProps> = ({
    selectedProviders,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { limit, planName, isWithinLimit } = useServiceProviderPlanLimit();
    const showFreeTrial = useShowFreeTrial();

    if (isWithinLimit(selectedProviders)) {
        return null;
    }

    return (
        <s-banner tone="warning">
            <s-button slot="secondary-actions" onClick={() => navigate(SettingUrls.billing)}>
                {showFreeTrial
                    ? t('WIZARD.SERVICE_PROVIDER_STEP.PLAN_LIMIT_BANNER.START_TRIAL', { count: FREE_TRIAL_DAYS })
                    : t('WIZARD.SERVICE_PROVIDER_STEP.PLAN_LIMIT_BANNER.UPGRADE_PLAN')}
            </s-button>
            {t('WIZARD.SERVICE_PROVIDER_STEP.PLAN_LIMIT_BANNER.DESCRIPTION', { count: limit, plan: planName })}
        </s-banner>
    );
};
